<template>
  <product-card-box id="visa-example-page" title="签证图例">
    <div class="visa-pic">
      <a :href="visaPage" target="_blank">
        <img :src="visaPage" />
      </a>
    </div>
  </product-card-box>

</template>

<script>
import ProductCardBox from './product-card-box.vue';

export default {
  name: 'visa-example-page',
  components: {
    ProductCardBox,
  },
  props: {
    visaPage: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>

.visa-pic{
  img{
    height: 256px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-example-page.vue